import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const EditMembershipPage = lazy(() => import("./EditMembershipPage"));
const NewChangeRequestPage = lazy(() => import("./NewChangeRequestPage"));
const EditMembershipSettings = lazy(() => import("./EditMembershipSettings"));
const MemberActivityListPage = lazy(() => import("./MemberActivityListPage"));

const membershipRoutes: RouteObject[] = [
  {
    path: "/members/:membershipId/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <EditMembershipPage />
      </Suspense>
    ),
    forceTurbo: true,
  },
  {
    path: "/members/:membershipId/change_requests/new", // deprecated
    element: (
      <Suspense fallback={<Loading />}>
        <NewChangeRequestPage />
      </Suspense>
    ),
  },
  {
    path: "/change_requests/new",
    element: (
      <Suspense fallback={<Loading />}>
        <NewChangeRequestPage />
      </Suspense>
    ),
  },
  {
    path: "/members/:membershipId/settings/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <EditMembershipSettings />
      </Suspense>
    ),
  },
  {
    path: "/members/:id/activities",
    element: (
      <Suspense fallback={<Loading />}>
        <MemberActivityListPage
          filterType="member"
          titleKey="js.memberships.activities.title"
        />
      </Suspense>
    ),
  },
  {
    path: "/members/:id/likes",
    element: (
      <Suspense fallback={<Loading />}>
        <MemberActivityListPage
          filterType="likes"
          titleKey="js.memberships.liked_activities.title"
        />
      </Suspense>
    ),
  },
];

export default membershipRoutes;
